import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';


import messages from '../../locale/jsonMessages';
import UnreadThreadsQuery from './getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './Message.css';

const Message = ({ allUnreadThreadsCount: { loading, getUnreadCount }, className, intl }) => {
  let count = 0;
  if (!loading && getUnreadCount != null) {
    count = getUnreadCount?.total != null ? getUnreadCount?.total : 0;
  }
  const isNewMessage = count > 0;

  return (
    <div className={className}>
      <span className={s.messagesWrapper}>
        <span><FormattedMessage {...messages.messages} /> </span>
        {isNewMessage && <span className={s.messageNotify} />}
      </span>
    </div>
  );
};

Message.propTypes = {
  allUnreadThreadsCount: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getUnreadCount: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }),
  }),
  className: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

Message.defaultProps = {
  allUnreadThreadsCount: {
    loading: true,
    getUnreadCount: {
      total: 0,
    },
  },
  className: '',
};

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
    },
  }),
)(Message);